export const RAPTOR_ADMIN_ROLE = 'raptoradmin';
